import { useNavigate } from 'react-router-dom';
import styled, { useTheme } from 'styled-components';
import { useSelector, useDispatch } from 'react-redux';

import Text from '../../../components/Text';
import { setRecent } from '../../../state/search/actions';
import Box from '../../../components/layout/Box';
import Icon from '../../../components/Icon';
import { FormattedMessage } from 'react-intl';
import Header from './Header';
import ProductListItem from '../../../components/ProductListItem';

const StyledBox = styled(Box)`
  position: fixed;
  flex-direction: column;
  top: 60px;
  box-sizing: border-box;
  background-color: ${(props) => props.theme.colors.mainBackgroundColor};
  z-index: 10000;
  overflow-y: scroll;

  @media (max-width: 768px) {
    left: 0px !important;
  }

  @media (min-width: 769px) {
    max-width: 500px;
  }
`;

const SearchCurrent = styled.div`
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  padding: 10px;
  align-items: center;
  border-radius: 6px;
  &:hover {
    background-color: #e2e2e2;
  }
  cursor: pointer;
`;

const RecentSearches = ({ searchString, products, onSearch, onReset }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const recent = useSelector((state) => state.search.recent);
  const shownRecent = recent.slice(0, 8);

  const { primaryColor, lightGrayColor, mediumGrayColor } = theme.colors;

  const leftNavbarOpen = useSelector(
    (state) => state.navigation.leftNavbarOpen,
  );

  const updateRecentSearches = (value) => {
    const filtered = recent.filter((str) => str !== value).slice(0, 9);
    const updatedRecentSearches = [value, ...filtered];
    dispatch(setRecent(updatedRecentSearches));
  };

  const handleRecentSearch = (event, value) => {
    event.stopPropagation();
    event.preventDefault();
    updateRecentSearches(value);
    onReset();
    navigate(`/search?q=${value}`);
  };

  const headerTitle = !searchString ? (
    <FormattedMessage defaultMessage="Senast sökt" />
  ) : (
    <FormattedMessage defaultMessage="Sökresultat" />
  );

  return (
    <StyledBox
      className="px-3 pt-3 flex-column"
      onMouseDown={(e) => {
        e.preventDefault();
      }}
      style={{
        bottom: 0,
        top: 64,
        right: 0,
        left: leftNavbarOpen ? 300 : 60,
        overflowY: 'scroll',
        borderRight: '1px solid #e6e6e6',
      }}
    >
      <Header onClose={onReset} title={headerTitle} />
      <Box className="flex-grow-1 flex-column flex-shrink-1 mt-2">
        {searchString && (
          <Box
            onClick={() => onSearch()}
            className="mb-2 pb-2"
            style={{
              borderBottom: '2px solid #e7e7e7',
            }}
          >
            <SearchCurrent>
              <Box
                style={{
                  marginRight: 8,
                  width: 34,
                  height: 34,
                  borderRadius: 999,
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: primaryColor,
                }}
              >
                <Icon name="search-outline" color="#ffffff" size={24} />
              </Box>
              <Box style={{ alignSelf: 'center' }}>
                <Text style={{ marginRight: 5 }}>Sök efter</Text>
                <Text style={{ fontWeight: '600' }}>{searchString}</Text>
              </Box>
            </SearchCurrent>
          </Box>
        )}
        {products?.map((product) => (
          <Box
            className="flex-column mb-2"
            key={product.id}
            onClick={() => onReset(product.id)}
          >
            <ProductListItem
              product={product}
              backgroundColor="whiteColor"
              showBorder={false}
            />
          </Box>
        ))}

        {!searchString && (
          <Box className="flex-column">
            {shownRecent.map((text, index) => {
              return (
                <Box
                  key={`recent-searches-${index}-${text}`}
                  onMouseDown={(e) => {
                    e.preventDefault();
                  }}
                  onClick={(event) => handleRecentSearch(event, text)}
                >
                  <SearchCurrent>
                    <Box
                      style={{
                        marginRight: 8,
                        width: 34,
                        height: 34,
                        borderRadius: 999,
                        justifyContent: 'center',
                        alignItems: 'center',
                        backgroundColor: mediumGrayColor,
                      }}
                    >
                      <Icon
                        name="clock-outline"
                        color={lightGrayColor}
                        size={22}
                      />
                    </Box>
                    {text}
                  </SearchCurrent>
                </Box>
              );
            })}
          </Box>
        )}
      </Box>
    </StyledBox>
  );
};

export default RecentSearches;
